import { render, staticRenderFns } from "./QrCodeGenerator.vue?vue&type=template&id=b5870aee&scoped=true"
import script from "./QrCodeGenerator.vue?vue&type=script&lang=js"
export * from "./QrCodeGenerator.vue?vue&type=script&lang=js"
import style0 from "./QrCodeGenerator.vue?vue&type=style&index=0&id=b5870aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5870aee",
  null
  
)

export default component.exports